import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

interface CustomTooltipProps extends Omit<TooltipProps, 'children'> {
  children: React.ReactElement;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ children, ...props }) => {
  return (
    <Tooltip 
      {...props}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: '#111827',
            '& .MuiTooltip-arrow': {
              color: '#111827',
            },
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;